<template>
    <div id="design-list-sidebar-menu" class="sidebar-menu-container">
            <div class="sidebar-main-label">
                Дизайн
            </div>
            <div id="new-design-frame">
                <div class="red-pill-button-of-hate" v-on:click="createNewDesign">Создать дизайн</div>
            </div>
        <DesignList ref="designList"
                    @selectDesign = 'selectDesign'
                    @openDesign = 'openDesign'
                    :isLite="false"
        />
    </div>
</template>

<script>
    import store from "../../../store";
    import DesignList from "./DesignListSidebarMenu/DesignList";

    export default {
        name: "DesignListSidebarMenu",
        components: {DesignList},
        methods: {
            selectDesign(designID) {
                this.$router.replace({name: "designListSelected", params: {designID: designID}}).catch(err => {
                });
            },
            async createNewDesign() {
                await store.dispatch(`active/ADD_DESIGN`, {});
            },
            openDesign(designID) {
                this.$router.push({name: "designMaterials", params: {designID: designID}}).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>
    #new-design-frame {
        border: 2px dashed #ACACAC;
        height: 158px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
    }

</style>
